
import { encodeCrosswordClue } from "@utils";
export default {
	name: "CrosswordClueEntry",
	props: {
		clue: {
			type: String,
			required: true,
		},
		visible: {
			type: Boolean,
			required: false,
			default: true,
		},
	},
	computed: {
		clueUrl() {
			return `/crosswords/clues/${encodeCrosswordClue(this.clue)}/`;
		},
	},
};
